// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-information-modal-component .modal2__container {
    width: 35%;
}


.page-information-modal-component .modal2__header p.modal2__header__title {
    text-transform: lowercase;
}

.page-information-modal-component .modal2__header p.modal2__header__title::first-letter {
    text-transform: uppercase;
}

.page-information-form__form__fields .baloa-normal-medium{
    color: var(--primary-dark-color);
}
.page-information-form__form {
    padding: 16px 60px;
}

.page-information-form__form__actions {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.page-information-form__form__input .input-field-label, 
.page-information-form__form__input .select-field-label{
    font-size: 14px;
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    position: sticky;
    text-transform: none;
}

.page-information-form__form__input .input-field-input,
.page-information-form__form__input .select-field-input {
    border: 1px solid var(--new-gray-background-color);
    background: var(--white-color);
    border-radius: 8px;
}

.page-information-form__form__input.input-field,
.page-information-form__form__input.select-field {
    margin: 12px 0;
}


.page-information-form__form__input .select-field-input.MuiInput-underline:before,
.page-information-form__form__input .select-field-input.MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom: unset;
}

.page-information-form__form__input .MuiListItemText-multiline .MuiListItemText-secondary {
    display: none;
}

#menu-page_type .MuiPaper-root{
    border-radius: 0px 0px 8px 8px;
}

#menu-page_type .MuiPaper-root .MuiList-padding{
    padding: 8px;
}

.page-information-form__form__content{
    display: flex;
}

.page-type-form-form-fields-text{
    display: flex;
    padding-left: var(--space-x2);
    padding-top: var(--space);
    justify-content: flex-start;
}

.page-type-form-form-fields-text_p p{
    padding-top: var(--space);
    padding-left: var(--space-x2);
}

.page-type-form__form__fields {
    padding: var(--space-half);
    display: flex;
    box-sizing: border-box;
    border: 1px solid transparent;
}

.page-type-form__form__actions {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

/*
.page-type-form__form__fields__icon {
    display: flex;
    flex-wrap: nowrap;

    justify-content: center;
    align-content: center;
    border: 1px solid var(--new-line-color);
    border-radius: var(--space);
}

.page-type-form__form__fields__info {
    display: grid;
    margin-left: var(--space-x2);
    justify-content: center;
    align-content: center;
    align-items: center;
    justify-items: start;
}

.page-type-form__form__fields__info .baloa-username{
    padding-top: var(--space);
    color: var(--basic-gray-color);
}

.page-type-form__form__fields__icon .icon-ball{
    padding: var(--space);
    font-size: var(--space-x2);
    color: var(--secondary-color);
}

.page-type-form__form__fields__icon .icon-company{
    padding: var(--space);
    font-size: var(--space-x2);
    color: var(--secondary-color);
}

.page-type-form__form__fields__icon .icon-pages-88{
    padding: var(--space);
    font-size: var(--space-x2);
    color: var(--secondary-color);
}

.page-type-form__form__fields__icon.active .icon-ball{
    color: var(--white-color);
    background-color: var(--new-green-color);
    border-radius: var(--space);
}

.page-type-form__form__fields__icon.active .icon-company{
    color: var(--white-color);
    background-color: var(--new-green-color);
    border-radius: var(--space);
}

.page-type-form__form__fields__icon.active .icon-pages-88{
    color: var(--white-color);
    background-color: var(--new-green-color);
    border-radius: var(--space);
}

.page-type-form__form__fields__icon:hover {
    cursor: pointer;
}
*/

.page-information-form__page-logo { 
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 24px;
}

.page-information-form__page-logo .input-field__message{
    margin-left: 0;
}

.page-information-form__page-logo .page-photo {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 1px dashed #7f9088;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 14px;
    cursor: pointer;
    background-color: #FAF8F8;
}

.page-information-form__page-logo .page-photo img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    justify-content: center;
    position: absolute;
}

.page-information-form__page-logo .page-photo .icon-image-70 {
    color: var(--new-green-color );
    font-size: var(--space );
    margin-right: 4px;
}

.page-information-form__page-logo .page-photo .baloa-mini {
    color: var(--new-green-color );
    font-weight: var(--font-medium );
}

@media screen and (min-width: 1441px){
    .page-information-form__page-logo .page-photo .baloa-mini {
        font-size: 12px;
    }
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .page-information-modal-component.modal2 {
        bottom: unset;
    }

    .page-information-modal-component .modal2__container {
        width: 100%;
        margin: 0;
        border-radius: 0;
    }

    .page-information-modal-component .modal2__header {
        padding: 16px 10px;
        border-bottom: unset;
    }

    .page-information-modal-component .modal2__content {
        padding-top: 24px;
    }

    .page-information-form__form {
        padding: 0 16px;
    }

    .page-information-form__form__actions {
        width: -webkit-fill-available;
        justify-content: center;
        position: fixed;
        bottom: 0;
        left: 0;
        margin-left: auto;
    }

    .page-information-form {
        height: 1000px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/page-information-modal/PageInformationModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;IACf,qCAAqC;IACrC,gCAAgC;IAChC,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,kDAAkD;IAClD,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;AAClB;;;AAGA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAgEC;;AAED;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;QAC7B,uBAAuB;QACvB,eAAe;QACf,SAAS;QACT,OAAO;QACP,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".page-information-modal-component .modal2__container {\n    width: 35%;\n}\n\n\n.page-information-modal-component .modal2__header p.modal2__header__title {\n    text-transform: lowercase;\n}\n\n.page-information-modal-component .modal2__header p.modal2__header__title::first-letter {\n    text-transform: uppercase;\n}\n\n.page-information-form__form__fields .baloa-normal-medium{\n    color: var(--primary-dark-color);\n}\n.page-information-form__form {\n    padding: 16px 60px;\n}\n\n.page-information-form__form__actions {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.page-information-form__form__input .input-field-label, \n.page-information-form__form__input .select-field-label{\n    font-size: 14px;\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    position: sticky;\n    text-transform: none;\n}\n\n.page-information-form__form__input .input-field-input,\n.page-information-form__form__input .select-field-input {\n    border: 1px solid var(--new-gray-background-color);\n    background: var(--white-color);\n    border-radius: 8px;\n}\n\n.page-information-form__form__input.input-field,\n.page-information-form__form__input.select-field {\n    margin: 12px 0;\n}\n\n\n.page-information-form__form__input .select-field-input.MuiInput-underline:before,\n.page-information-form__form__input .select-field-input.MuiInput-underline:hover:not(.Mui-disabled):before {\n    border-bottom: unset;\n}\n\n.page-information-form__form__input .MuiListItemText-multiline .MuiListItemText-secondary {\n    display: none;\n}\n\n#menu-page_type .MuiPaper-root{\n    border-radius: 0px 0px 8px 8px;\n}\n\n#menu-page_type .MuiPaper-root .MuiList-padding{\n    padding: 8px;\n}\n\n.page-information-form__form__content{\n    display: flex;\n}\n\n.page-type-form-form-fields-text{\n    display: flex;\n    padding-left: var(--space-x2);\n    padding-top: var(--space);\n    justify-content: flex-start;\n}\n\n.page-type-form-form-fields-text_p p{\n    padding-top: var(--space);\n    padding-left: var(--space-x2);\n}\n\n.page-type-form__form__fields {\n    padding: var(--space-half);\n    display: flex;\n    box-sizing: border-box;\n    border: 1px solid transparent;\n}\n\n.page-type-form__form__actions {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n/*\n.page-type-form__form__fields__icon {\n    display: flex;\n    flex-wrap: nowrap;\n\n    justify-content: center;\n    align-content: center;\n    border: 1px solid var(--new-line-color);\n    border-radius: var(--space);\n}\n\n.page-type-form__form__fields__info {\n    display: grid;\n    margin-left: var(--space-x2);\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n    justify-items: start;\n}\n\n.page-type-form__form__fields__info .baloa-username{\n    padding-top: var(--space);\n    color: var(--basic-gray-color);\n}\n\n.page-type-form__form__fields__icon .icon-ball{\n    padding: var(--space);\n    font-size: var(--space-x2);\n    color: var(--secondary-color);\n}\n\n.page-type-form__form__fields__icon .icon-company{\n    padding: var(--space);\n    font-size: var(--space-x2);\n    color: var(--secondary-color);\n}\n\n.page-type-form__form__fields__icon .icon-pages-88{\n    padding: var(--space);\n    font-size: var(--space-x2);\n    color: var(--secondary-color);\n}\n\n.page-type-form__form__fields__icon.active .icon-ball{\n    color: var(--white-color);\n    background-color: var(--new-green-color);\n    border-radius: var(--space);\n}\n\n.page-type-form__form__fields__icon.active .icon-company{\n    color: var(--white-color);\n    background-color: var(--new-green-color);\n    border-radius: var(--space);\n}\n\n.page-type-form__form__fields__icon.active .icon-pages-88{\n    color: var(--white-color);\n    background-color: var(--new-green-color);\n    border-radius: var(--space);\n}\n\n.page-type-form__form__fields__icon:hover {\n    cursor: pointer;\n}\n*/\n\n.page-information-form__page-logo { \n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    margin-bottom: 24px;\n}\n\n.page-information-form__page-logo .input-field__message{\n    margin-left: 0;\n}\n\n.page-information-form__page-logo .page-photo {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    border: 1px dashed #7f9088;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 14px;\n    cursor: pointer;\n    background-color: #FAF8F8;\n}\n\n.page-information-form__page-logo .page-photo img {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    justify-content: center;\n    position: absolute;\n}\n\n.page-information-form__page-logo .page-photo .icon-image-70 {\n    color: var(--new-green-color );\n    font-size: var(--space );\n    margin-right: 4px;\n}\n\n.page-information-form__page-logo .page-photo .baloa-mini {\n    color: var(--new-green-color );\n    font-weight: var(--font-medium );\n}\n\n@media screen and (min-width: 1441px){\n    .page-information-form__page-logo .page-photo .baloa-mini {\n        font-size: 12px;\n    }\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .page-information-modal-component.modal2 {\n        bottom: unset;\n    }\n\n    .page-information-modal-component .modal2__container {\n        width: 100%;\n        margin: 0;\n        border-radius: 0;\n    }\n\n    .page-information-modal-component .modal2__header {\n        padding: 16px 10px;\n        border-bottom: unset;\n    }\n\n    .page-information-modal-component .modal2__content {\n        padding-top: 24px;\n    }\n\n    .page-information-form__form {\n        padding: 0 16px;\n    }\n\n    .page-information-form__form__actions {\n        width: -webkit-fill-available;\n        justify-content: center;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        margin-left: auto;\n    }\n\n    .page-information-form {\n        height: 1000px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
